var map = {
	"./back0.png": "T/6V",
	"./back1.png": "lwQv"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "G7x9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index ^\.\/back.*\.png$
// module id = G7x9
// module chunks = 3